<template>
	<section :class="[`bg-color-${props.backgroundColor}`]">
		<div
			:class="[
				{
					'container py-100': props.addContainerClass
				}
			]"
		>
			<div
				:class="[
					'display-flex flex-direction-column-smo align-items-center mt-300 gap-300 gap-100-md',
					wrapperCss
				]"
			>
				<div
					v-for="stat in props.stats"
					:key="stat.stat"
					:class="[
						'display-flex flex-direction-column align-items-center text-align-center-smo',
						{
							'flex-direction-row-lg': props.horizontallyAligned
						}
					]"
				>
					<div class="heading-1">{{ stat.stat }}</div>
					<div
						:class="[
							{
								'mt-25 mt-0-lg ml-75-lg': props.horizontallyAligned
							}
						]"
						v-html="stat.description"
					></div>
				</div>
			</div>
			<slot name="disclaimer">
				<p v-if="props.disclaimer" class="body-xs text-color-content-tertiary text-align-center mt-250">{{
					props.disclaimer
				}}</p>
			</slot>
		</div>
	</section>
</template>

<script setup lang="ts">
import { FeaturedStat } from 'types/marketing-site';

interface Props {
	backgroundColor?: string;
	disclaimer?: string;
	stats: Array<FeaturedStat>;
	addContainerClass?: boolean;
	horizontallyAligned?: boolean;
	wrapperCss?: string;
}

const props = withDefaults(defineProps<Props>(), {
	backgroundColor: 'white',
	disclaimer: '',
	addContainerClass: true,
	horizontallyAligned: true,
	wrapperCss: 'justify-content-space-between'
});
</script>
